module.exports = __webpack_public_path__ + "static/media/pulsar.d3a25063.svg";